<div class="modal-header">
  <h4 id="information-dialog-modal" class="modal-title">
    <fa-icon [icon]="icon" class="me-2"></fa-icon>
    {{ title || ("Please note" | translate) }}
  </h4>
  <button (click)="modal.dismiss()" class="close" aria-describedby="modal-title" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <p [innerHTML]="message | translate: messageClass" [ngClass]="messageClass" style="white-space: pre-line"></p>
</div>

<div class="modal-footer">
  <!-- Custom buttons if provided -->
  <ng-container *ngIf="buttons && buttons.length > 0">
    <button
      *ngFor="let button of buttons"
      [class.loading]="loadingService.loading$ | async"
      [class]="'btn ' + button.class"
      (click)="executeButtonAction(button)"
      type="button"
    >
      {{ button.label | translate }}
    </button>
  </ng-container>

  <!-- Default close button if no custom buttons -->
  <button
    *ngIf="!buttons || buttons.length === 0"
    [class.loading]="loadingService.loading$ | async"
    (click)="modal.close()"
    class="btn btn-secondary"
    type="button"
  >
    {{ "Close" | translate }}
  </button>
</div>
